import { ChatStreamHandler } from '@src/handlers/ChatStreamHandler';
import { MessageInterface } from '@type/chat';
import { AIProviderBase, RequestConfig } from '@type/provider';

export class ChatSubmissionService {
  constructor(
    private provider: AIProviderBase,
    private apiKey: string,
    private onContent: (content: string) => void,
    private streamHandler: ChatStreamHandler
  ) {}

  async submit(messages: MessageInterface[], config: RequestConfig): Promise<void> {
    // Use provider to format request
    const formattedRequest = this.provider.formatRequest(messages, config);
    
    // Route to correct API endpoint based on provider
    const endpoint = `/api/chat/${this.provider.id}`;
    
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        formattedRequest,
        apiKey: this.apiKey
      })
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    if (config.stream) {
      await this.handleStream(response);
    } else {
      const data = await response.json();
      const content = this.provider.parseResponse(data);
      this.onContent(content);
    }
  }

  private async handleStream(response: Response): Promise<void> {
    const reader = response.body?.getReader();
    if (!reader) throw new Error('No stream reader available');

    await this.streamHandler.processStream(reader, this.onContent);
  }
}